import { useState } from "react";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import type { SignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

type UseShowMoreSignalEventsProps = {
    hasShowMoreButton: boolean;
    signalEvents: readonly SignalEventDto[];
};

type UseShowMoreSignalEventsReturnProps = {
    isShowMoreButtonVisible: boolean;
    signalEventsToRender: readonly SignalEventDto[];
    onShowMoreClick: () => void;
};

const MAX_SIGNAL_EVENTS_QUANTITY = 5;

const useShowMoreSignalEvents = ({
    signalEvents,
    hasShowMoreButton,
}: UseShowMoreSignalEventsProps): UseShowMoreSignalEventsReturnProps => {
    const [isShowMoreEnabled, setIsShowMoreEnabled] = useState(false);

    const onShowMoreClick = () => {
        setIsShowMoreEnabled(true);
        companyAnalysisTrackingService.signalEvents.trackClickOnShowMore(signalEvents.length);
    };

    const isShowMoreButtonAvailable = hasShowMoreButton && signalEvents.length > MAX_SIGNAL_EVENTS_QUANTITY;

    let signalEventsToRender = signalEvents;

    if (isShowMoreButtonAvailable) {
        signalEventsToRender = isShowMoreEnabled ? signalEvents : signalEvents.slice(0, MAX_SIGNAL_EVENTS_QUANTITY);
    }
    const isShowMoreButtonVisible = isShowMoreButtonAvailable && !isShowMoreEnabled;

    return {
        isShowMoreButtonVisible,
        onShowMoreClick,
        signalEventsToRender,
    };
};

export default useShowMoreSignalEvents;
